import { PlatformRole } from "~/config/types";

/** Superadmins and coordinators may create, edit and invite to quizzes. */
export const canManageQuizzes = (role: PlatformRole): boolean =>
  role === PlatformRole.superAdmin || role === PlatformRole.coordinator;
